/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-28 09:20:12
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 18:00:35
 * @name: 通讯录模块api
 * @Description: 通讯录模块api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\mailList\mailList.api.js
 * @Author: DESKTOP-1QU67QM
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';
import { Message } from "element-ui";
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取通讯录树结构数据
 * @param {Object} data 无
 */
export const departmentGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/department/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 部门信息
 * @param {Object} data {id{String}: 部门id}
 */
export const departmentDetail = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/department/detail.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 部门添加
 * @param {Object} data ==> {name{String}: 部门名称,parent_id{Number}: 上级部门id}
 */
export const departmentAdd = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  try {
    if (!data.name) {
      throw '请输入部门名称!';
    }
    return apiAddInstance.post('/admin/department/add.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 部门编辑
 * @param {Object} data ==> {department_id{Number}: 部门id,name{String}: 部门名称,parent_id{Number}: 上级部门id}
 */
export const departmentEdit = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  try {
    if (!data.name) {
      throw '请输入部门名称!';
    }
    return apiEditInstance.post('/admin/department/edit.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 部门删除
 * @param {Object} data ==> {department_id{Number}: 部门id,name{String}: 部门名称,parent_id{Number}: 上级部门id}
 */
export const departmentDelete = (data) => {
  const instance = axios.create();
  const apiDeleteInstance = new apiDelete();
  return apiDeleteInstance.post('/admin/department/delete.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取部门人员
 * @param {Object} data  ==> {department_id{Number}: 部门id,page{Number}: 页码, limit{Number}: 每页数据量}
 * @return {Object} data -> {total{Number}:数据总量, list{Array}:数据} list ==> {id{Number}: 人员id,realname{String}: 姓名,mobile{String}:手机号码,department_id{Number}:部门id,department{Object}:部门信息,roles{String}:职位}
 */
export const userGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/department/user/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取部门所有人员
 * @return {Object} data -> {total{Number}:数据总量, list{Array}:数据} list ==> {id{Number}: 人员id,realname{String}: 姓名,mobile{String}:手机号码,department_id{Number}:部门id,department{Object}:部门信息,roles{String}:职位}
 */
export const userGetAllList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/department/user/getAllList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 职位列表
 */
export const roleGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/department/role/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 部门添加人员
 * @param {Object} data ==> {realname{String}: 姓名,mobile{String}: 手机号,department_id{Number}: 部门id,role_id{String}:职位id}
 */
export const userAdd = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  try {
    if (!data.realname) {
      throw '请输入姓名!';
    }
    if (!data.mobile || data.mobile.length !== 11) {
      throw '请输入正确的手机号!';
    }
    if (!data.department_id) {
      throw '请选择所属部门!';
    }
    if (!data.role_id) {
      throw '请选择职位!';
    }
    return apiAddInstance.post('/admin/department/user/add.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 部门编辑人员
 * @param {Object} data ==> {id{String}: 人员id,realname{String}: 姓名,mobile{String}: 手机号,department_id{Number}: 部门id,role_id{String}:职位id}
 */
export const userEdit = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiEdit();
  try {
    if (!data.realname) {
      throw '请输入姓名!';
    }
    if (!data.mobile || data.mobile.length !== 11) {
      throw '请输入正确的手机号!';
    }
    if (!data.department_id) {
      throw '请选择所属部门!';
    }
    if (!data.role_id) {
      throw '请选择职位!';
    }
    return apiAddInstance.post('/admin/department/user/edit.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 批量删除人员
 * @param {Object} data ==> {user_ids{Array}: 成员id数组}
 */
export const userDelete = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/department/user/delete.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 批量调整成员的部门
 * @param {Object} data ==> {user_ids{Array}:成员ID数组,department_id{Number}:要更换到的部门ID}
 */
export const userDepartmentChange = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  return apiEditInstance.post('/admin/department/user/change.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取待审核人员列表
 */
export const userGetVerifyList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/department/user/getVerifyList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 审核人员
 */
export const userVerify = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  try {
    if (data.act === 'OK' && !data.department_id) {
      throw '请选择所属部门!';
    }
    if (data.act === 'OK' && !data.role_id) {
      throw '请选择职位!';
    }
    return apiSearchInstance.post('/admin/department/user/verify.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 查询erp内部人员
 */
export const getErpUsers = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/department/user/getErpUsers.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 内部人员绑定erp
 */
export const setErpUser = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/department/user/setErpUser.html', data, instance);
}